
import React from 'react';

interface ProfileContentLayoutProps {
  mainContent: React.ReactNode;
  sidebar: React.ReactNode;
}

const ProfileContentLayout = ({ mainContent, sidebar }: ProfileContentLayoutProps) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="order-2 lg:order-1 lg:col-span-2 space-y-6">
        {mainContent}
      </div>
      
      <div className="order-1 lg:order-2">
        {sidebar}
      </div>
    </div>
  );
};

export default ProfileContentLayout;
